import { Link } from 'react-router-dom';
import { useScrollReveal } from '@/hooks/useScrollReveal';

export default function StoresFaqCTA() {
  const section = useScrollReveal();

  return (
    <section className="relative w-full min-h-[80svh] flex items-center px-6 md:px-10 py-24 md:py-32 bg-primary-950/80 overflow-hidden" ref={section.ref}>
      <div
        className="absolute inset-0"
        style={{
          background: 'radial-gradient(ellipse 50% 40% at 30% 50%, oklch(var(--primary-950) / 0.2), transparent)',
        }}
      ></div>

      <div className="absolute top-0 left-0 right-0 h-px bg-background-50/6"></div>
      <div className="absolute bottom-0 left-0 right-0 h-px bg-background-50/6"></div>

      <div className="absolute top-6 right-6 md:top-10 md:right-14 select-none pointer-events-none">
        <span className="font-heading text-5xl md:text-7xl font-bold text-background-50/[0.025]">05</span>
      </div>

      <div className="absolute left-8 md:left-14 top-1/2 -translate-y-1/2 w-1 h-20 md:h-28 rounded-full bg-primary-500/20"></div>

      <div className={`relative z-10 w-full max-w-3xl mx-auto text-center transition-all duration-700 ease-out ${section.isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
        <div className="inline-flex items-center gap-3 mb-7">
          <span className="block w-5 h-px bg-primary-400/40"></span>
          <span className="text-[13px] text-primary-400/80 tracking-[0.15em] uppercase font-medium">探索更多</span>
          <span className="block w-5 h-px bg-primary-400/40"></span>
        </div>

        <h2 className="font-heading text-[2.25rem] md:text-[3rem] lg:text-[3.5rem] font-semibold text-background-50 mb-5 leading-[1.2] tracking-tight">
          從樂律文化，找到下一本值得閱讀的書
        </h2>

        <p className="text-base md:text-lg text-background-50/50 leading-relaxed max-w-xl mx-auto mb-11 font-light tracking-wide">
          透過樂律文化目前公開的正式出版內容，瀏覽書籍介紹、查詢完整書目，並由合作購書通路選擇適合的平台。
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 mb-10">
          <Link
            to="/stores"
            className="whitespace-nowrap inline-flex items-center gap-2.5 px-8 py-3.5 rounded-full text-[15px] font-medium bg-primary-500 text-white hover:bg-primary-600 transition-colors cursor-pointer tracking-wide"
          >
            查看合作購書通路
            <i className="ri-arrow-right-line text-[13px]"></i>
          </Link>
          <Link
            to="/faq"
            className="whitespace-nowrap inline-flex items-center gap-2.5 px-8 py-3.5 rounded-full text-[15px] font-medium bg-gradient-to-r from-accent-500 to-primary-500 text-white hover:from-accent-600 hover:to-primary-600 transition-all cursor-pointer tracking-wide"
          >
            常見問題
            <i className="ri-arrow-right-line text-[13px]"></i>
          </Link>
        </div>

        {/* Brand summary */}
        <div className="mt-10 max-w-2xl mx-auto">
          <p className="text-[15px] text-background-50/35 leading-relaxed font-light tracking-wide">
            本品牌委託崧博出版經銷，官方網站由崧博出版製作。網站提供正式品牌介紹、出版書籍、合作購書通路及書籍資料庫入口。完整書目請以崧博出版書籍資料庫為準，價格、庫存、版本與購買方式則以各合作通路頁面為準。
          </p>
        </div>
      </div>
    </section>
  );
}